module.exports = __webpack_public_path__ + "static/media/hero21.a6ecbc85.jpg";